import { Input, Loader, Button } from "@thdinc/hpf-shared";
import React, { useEffect, useState } from "react";
import SelectSearch from "react-select-search";
import { useDispatch } from "react-redux";
import { formStateChange } from "@/redux/slices/formSlice";
import { ingredientInterface } from "@/pages/company/interface";
import { FaCirclePlus } from "react-icons/fa6";
import FormModal from "@/components/modals/FormModal";
import deleteIcon from "../../../assets/icons/deleteIcon.svg";

interface product {
  name: string;
  value: string;
}

interface AddCocktailIngredients {
  name?: string;
  qty_oz: string;

  product_id?: string | null;
  other?: boolean;
}

interface selectedProduct {
  value: string;
  name: string;
}

interface Props {
  productsList: product[];
  CurInggrediant?: ingredientInterface[];
  saveCocktail: (list: AddCocktailIngredients[]) => void;
  loading: boolean;
  prev?: () => void;
  isNew?: boolean;
  isCustomCocktail?:boolean;
  setNewIngredientFn?: (any: any) => void;
}
const IngrediantsBTC: React.FC<Props> = ({
  productsList,
  saveCocktail,
  CurInggrediant,
  loading,
  prev,
  isNew,
  setNewIngredientFn,
  isCustomCocktail,
}) => {
  const dispatch = useDispatch();
  const updatedProdoctList =isCustomCocktail ?productsList : [...productsList, { value: "other", name: "other" }]
  const producIds = updatedProdoctList.map((p)=> p.value)
  const [ingList, setIngList] = useState<AddCocktailIngredients[]>([]);
  const [other, setOther] = useState<{ id: number; state: boolean }>();
  const [productName, setProductName] = useState<string>("");
  const [selectedProduct, setSelectedProduct] = useState<selectedProduct>({
    value: productsList[0].value,
    name: productsList[0].name,
  });
  // const [qty, setQty] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [ingTotal, setIngTotal] = useState<number>(0);
  const defaultInputs = 5 // no of open ingredient fields
  const defaultIng =   { qty_oz: "", name: "", product_id: "", other: false } // default emppty ingredient
  useEffect(()=>{
    // update selected ingrediants if user select toggle filtered ings on the base of currrent products
    if(isCustomCocktail)
      {
      const updated= ingList.filter((ing)=>{
        // filter where selected ing is in filtered product
      if(ing.product_id !=='' &&  producIds.includes(ing.product_id as string)){
        return ing
      }
        // or keep the input ingrediant input as it is
      else if(ing.product_id ==='' || ing.product_id ===null){
        return ing
      }
    })

    setIngList(updated)}
  },[isCustomCocktail,updatedProdoctList])
  useEffect(() => {
    if (CurInggrediant && CurInggrediant?.length > 0) {
      const currentIng=  CurInggrediant.map((i: any) => {
        return {
          ...i,
          qty_oz: i.qty_oz / 100,
          other: i.product_id ? false : true,
        };
      })
      // add default inputs if ing list less than 5
    if(currentIng.length <5){
      const extra = defaultInputs -  CurInggrediant.length 
      for (let index = 0; index < extra; index++) {
           currentIng.push(defaultIng)          
      }
    }
    setIngList(currentIng)
    } else {
      setIngList([
        { qty_oz: "", name: "", product_id: "", other: false },
        { qty_oz: "", name: "", product_id: "", other: false },
        { qty_oz: "", name: "", product_id: "", other: false },
        { qty_oz: "", name: "", product_id: "", other: false },
        { qty_oz: "", name: "", product_id: "", other: false },
      ]);
    }
  }, [CurInggrediant]);

  useEffect(() => {
    setNewIngredientFn && setNewIngredientFn(ingList);
  }, [ingList]);
  

  /* istanbul ignore next */
  const handleChange = (selectedOption: any, id: number) => {
    dispatch(formStateChange(true));
    if (selectedOption == "other") {
      setOther({ id, state: true });
    } else {
      setOther({ id, state: false });
      setProductName("");
    }

    const find = productsList.find((p) => p.value == selectedOption);
    if (find) {
      setSelectedProduct(find);
    }
    //  new Implementations
    // update the brand name or add
    if (id >= 0) {
      const updated = ingList.map((p, index) => {
        if (index === id) {
          return{...p,name: selectedOption == "other" ? productName : find?.name,
            product_id:selectedOption == "other" ? null : find?.value,
            other:selectedOption == "other" ? true : false
          }
        }
        return p;
      });
      setIngList(updated);
    }
  };
  /* istanbul ignore next */
  const removeIngredient = (index: number) => {
    dispatch(formStateChange(true));
    // remove ingredient from the list
    const list = [...ingList];
    list.splice(index, 1);
    setIngList(list);
  };

  /* istanbul ignore next */
  const saveClicked = () => {
    // vali
    ingList.map((i) => {
      if (i.qty_oz !== "") {
        setError("");
      }
    });

    const filtered = ingList.filter((i) => {
      if (
        i.qty_oz !== "" &&
        parseFloat(i.qty_oz) > 0 &&
        parseFloat(i.qty_oz) <= 15
      ) {
        return i;
      }
    });
    if (filtered.length === 0) {
      setError("Please add ingrdients");
    } else {
      saveCocktail(filtered);
    }
  };
  const handleOnBlurOz = (
    e: React.ChangeEvent<HTMLInputElement>,
    ingIndex: number
  ) => {
    const updated = ingList.map((p, index) => {
      if (index === ingIndex) {
        p.qty_oz = e.target.value;
        // Update the brand name if update
        if(p.other){
          p.name =productName 
        }
      }
      return p;
    });
    setIngList(updated);
  };
  const updateOtherNameFun =(name:string,i:number)=>{
    setProductName(name)
   setIngList( ingList.map((ing,index)=>{
      if(index ===i){
          ing.name = name
      }
      return ing
    }))
  }
  useEffect(() => {
    const totalIgredients = () => {
      const total = ingList.reduce((acc, cur) => {
        if (
          cur.qty_oz !== "" &&
          parseFloat(cur.qty_oz) > 0 &&
          parseFloat(cur.qty_oz) <= 15
        ) {
          return acc + parseFloat(cur.qty_oz);
        }
        return acc;
      }, 0);
     
      setIngTotal(total);
    };
    totalIgredients();
  }, [ingList]);
  // const haveOtherProductInList = ingList.find((i)=> i.product_id ===null)
  return (
    <div className="flex flex-col justify-between h-full">
      <div>
        <div className="flex justify-between items-center">
          <p className="font-semibold mb-4 text-xl">
            Ingredients
            {ingTotal > 0 && (
              <span className="bg-primary-red py-1 px-2 rounded-lg text-white text-sm ml-2">
                {ingTotal.toFixed(2)}
              </span>
            )}
          </p>
        </div>
        {ingList.map((ing: AddCocktailIngredients, i: number) => {
          return (
            <div
              className="p-3   flex sm:flex-row lg:flex-nowrap flex-wrap flex-col justify-center w-full items-start gap-2  "
              key={i}
            >
              <div className="w-full  ">
                {/* {i===0 && <p className="font-semibold mb-2">Select Brand</p>} */}
                <SelectSearch
                  options={updatedProdoctList}
                  value={ing.other ? "other" : (ing.product_id as string)}
                  onChange={(e) => handleChange(e, i)}
                  data-testid="search-id"
                  search
                  placeholder={"Select Product"}
                />
              </div>
                <div className={`${ing.other && 'w-full'}`}>
                {/* {i===0  && !!haveOtherProductInList  && <p className="font-semibold mb-2 min-w-36">Other Name</p>} */}
              {ing.other && (
                  <div  className="w-full  ">

                  <Input
                    className="w-full px-4 py-2 bg-p-gray rounded-full    focus:outline-none min-w-36 focus:ring-1 focus:ring-primary-red text-gray-600"
                    maxLength={50}
                    defaultValue={ing.name}
                    onChange={(e) => {
                      updateOtherNameFun(e.target.value,i)
                      setProductName(e.target.value);
                    }}
                    placeholder="Name"
                  />
                 
                  </div>

                )}
                </div>
              <div className="sm:w-3/12 w-full md:min-w-28 ">
                {/* {i===0 && <p className="font-semibold mb-2">Quantity (Oz)</p>} */}
                <Input
                  onChange={(e) => handleOnBlurOz(e, i)}
                  className="w-full px-4 py-2 bg-p-gray rounded-full  text-sm   focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  type="number"
                  min={1}
                  value={ing.qty_oz}
                  placeholder="Quantity (Oz)"
                  // onChange={(e: any) => setQty(e.target.value)}
                />
                {parseFloat(ing.qty_oz) <= 0 && (
                  <p className="text-xs text-primary-red">{"Invalid value"}</p>
                )}
                {parseInt(ing.qty_oz) >= 15 && (
                  <p className="text-xs text-primary-red">
                    {"Quantity must not be greater than 15"}
                  </p>
                )}
              </div>
              <div
                onClick={() => {
                  removeIngredient(i);
                }}
                className={`cursor-pointer p-2 bg-p-gray rounded-full font-bold`}
                data-testid="delete-icon "
              >
                <img
                  src={deleteIcon}
                  width={20}
                  className="min-w-[14px] w-[14px]"
                />
              </div>
            </div>
          );
        })}
        <div
          data-testid="add-ingredient-btn"
          onClick={() => setIngList([...ingList, { qty_oz: "", other: false }])}
          className=" inline-block cursor-pointer"
        >
          <FaCirclePlus className="cursor-pointer text-gray-400 text-xl ml-4 " />
        </div>

        {error && <p className="text-sm text-primary-red">{error}</p>}
      </div>
      <div className="flex justify-end mt-8 gap-4">
        <Button
          classes={
            "bg-primary-red text-white hover:bg-primary-red-button-hover "
          }
          disabled={loading}
          onClick={saveClicked}
        >
          {loading ? <Loader data-testid="loader"  color="bg-gray-50"  /> : "Save"}
        </Button>
      </div>
    </div>
  );
};

export default IngrediantsBTC;
